export default __webpack_public_path__ + "static/media/checkAlert.f36846da.svg";